import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useNavigate } from 'react-router-dom';
import { useWorkspaceGuide } from '@/hooks/api/2420_workspace_guide';
import { useEffect } from 'react';

export const useIntercomGuide = () => {
  const { _w_ } = useCurrentWorkspace();
  const navigate = useNavigate();
  const { data: workspaceGuide } = useWorkspaceGuide({ identifier: _w_!.identifier });
  useEffect(() => {
    if (workspaceGuide && workspaceGuide.guide != null) {
      navigate(`${location.pathname}?guide=${workspaceGuide.guide}`);
    }
  }, [workspaceGuide]);
};
